import { chakra, Tab } from "@chakra-ui/react";

export const StyledUserDetailTab = chakra(Tab, {
    baseStyle: {
        color: 'theme.gray.400',
        fontWeight: 500,
        _selected: {
            color: "theme.button.primary",
            borderColor: "theme.button.primary"
        }
    }
})